const typography = {
	styleOverrides: {
		root: ({ theme }) => ({
			color: theme.palette.white[900],
		}),
	},
};

export default typography;
